var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',{staticClass:"text-center"},[_c('pages-btn',{staticClass:"v-btn--text success--text",attrs:{"large":"","color":"","depressed":""},on:{"click":_vm.login}},[_vm._v(" "+_vm._s(_vm.$t('Connexion'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }